import script from "./CellEditMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./CellEditMenu.vue?vue&type=script&setup=true&lang=ts"

import "./CellEditMenu.vue?vue&type=style&index=0&id=6c15fe80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c15fe80"]])

export default __exports__